import classNames from 'classnames';
import { useEffect, useRef } from 'react';

import playerService from 'src/services/player/service';

import styles from './ViewWindow.module.scss';

interface IViewWindow {
  name: string;
  liveMode: boolean;
  src?: string;
}

const ViewWindow = ({ name, liveMode, src }: IViewWindow) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // Connect to player when iframe loads
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe || !src) return;

    const connectToPlayer = () => {
      playerService.connect(iframe, {
        load: () => console.log('Player connected'),
        unload: () => console.log('Player disconnected'),
      });
    };

    iframe.addEventListener('load', connectToPlayer);

    return () => {
      iframe.removeEventListener('load', connectToPlayer);
      playerService.disconnect(iframe);
    };
  }, [src]);

  const rowClass = classNames(styles.Row, {
    [styles.Live]: liveMode,
    [styles.Sandbox]: !liveMode,
  });

  return (
    <div className={styles.WindowWrapper}>
      <div className={styles.Window}>
        <div className={styles.Wrapper}>
          {src ? (
            <iframe
              ref={iframeRef}
              className={styles.Frame}
              src={`${src}&checkerboard`}
              title={`${name} output`}
            />
          ) : (
            <div className={styles.Frame}>Could not find output</div>
          )}
          <div
            className={classNames(
              'relative w-full h-6 flex justify-center items-center bg-elevated-2 text-center gap-2',
              rowClass
            )}
          >
            <span className={classNames(styles.Name, liveMode && '!text-live')}>{name}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewWindow;
